import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
// import { faqs } from "./acceleratedCashbackData";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ctaImage from '../../pages/mystery-box/images/bg-top.png';
import Heading from '../../pages/mystery-box/images/top-heading.png';
import Unlock from '../../pages/mystery-box/images/unlock.png';
import Bg from '../../pages/mystery-box/images/state-bg.png';
import Bonus from '../../pages/mystery-box/images/bonus.png';
import Gradiant from '../../pages/mystery-box/images/Gradient.png';
import ReactHtmlParser from 'html-react-parser';
import OpenBox from '../../pages/mystery-box/images/openBox.gif'



const faqs = [
  {
    question: "What is the Mystery Gift Box?",
    answer: "The Mystery Gift Box is a special offer where you can unlock a Bonus Cashback of up to ₹500 on your next transaction till 28th February 2026."
  },
  {
    question: "How do I unlock & claim my Mystery Bonus? ",
    answer:  "To unlock the Mystery Bonus, you must first register and then shop from an eligible retailer that offers Cashback / Rewards.  When you complete the transaction, wait 24 - 48 hours after it is tracked and reflected in “My Earnings” section on the CashKaro app. Once updated, your Mystery Bonus will unlock and can be claimed by tapping the gift box on this offer landing page. "
  },
  {
    question: "Can I unlock the Bonus on any transaction? ",
    answer: "This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback/ Rewards are unavailable. Any other successful transaction within the offer period will make you eligible to unlock the Bonus."
  },
  {
    question: "Can I claim the Bonus more than once in a month? ",
    answer: "No, each user is eligible for only one Mystery Bonus per month."
  },
  {
    question: "What happens if I cancel my transaction after unlocking the Bonus? ",
    answer: "If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed. However, you can still make another valid transaction within the offer period to confirm and claim your Bonus. "  
  },
  {
    question: "How long does it take for my Bonus to be credited? ",
    answer: "The Bonus amount will be added to your CashKaro account within 48 – 72 hours of claiming. It will appear in Pending state in “My Earnings” section on your CashKaro app/ website. The Bonus will be confirmed and credited within 10 days after the transaction linked to it is Confirmed and Validated."
  },
  {
    question: "Can my Bonus be changed or canceled? ",
    answer: "Once the Bonus is unlocked and claimed, it cannot be altered. However, if your qualifying transaction is canceled or invalid, and no other valid transaction is made during the offer period, the Bonus will be cancelled."
  }
];
const Terms = [
  {
    question: "Eligibility Criteria",
    answer: `<ul>
    <li>This offer is valid only for users who have received official communication from CashKaro about it.</li>
    <li>Each user is eligible for only one Mystery Bonus per month.</li>
  </ul>`},
  {
    question: "Bonus Unlock & Tracking Process",
    answer: `<ul>
    <li>To unlock the Mystery Bonus, users must first register and then shop from an eligible retailer that offers Cashback / Rewards.</li>
    <li>Upon completing the transaction, users must wait 24 - 48 hours after it is added and reflected in the "My Earnings" section before their Mystery Bonus unlocks and can be claimed.</li>
    <li>The unlocked Mystery Bonus will be available for claiming on the offer landing page.</li>
    <li>The Bonus amount will be added to the user’s CashKaro account within 48 - 72 hours after the claim.</li>
    <li>It will be reflected in pending state in the “My Earnings” section of the user's account on the CashKaro app or website.</li>
    <li>The Bonus will be confirmed and credited within 10 days after the transaction linked to it is Confirmed and Validated.</li>
    <li>This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback is unavailable.</li>

  </ul>`},
  {
    question: "Bonus Amount Allocation",
    answer: `<ul>
    <li>The Bonus is randomly assigned and can be up to ₹500. The assigned amount is final and cannot be changed or influenced.</li>
    <li>Only transactions made within the offer period will be eligible to unlock the Mystery Bonus.</li>
  </ul>`},
  {
    question: "Disqualification Criteria",
    answer: `<ul>
    <li>If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed.</li>
    <li>However, the user can still complete another valid transaction within the offer period to confirm and claim their Bonus.</li>
    <li>CashKaro reserves the right to revoke the Bonus if fraudulent activity, misuse, or policy violations are detected.</li>
  </ul>`},
  {
    question: "Modification & Termination",
    answer: `<ul>
    <li>Changes to the terms, eligibility, or Bonus structure will be communicated at CashKaro’s discretion.</li>
  </ul>`},
  {
    question: "General Terms",
    answer: `<ul>
    <li>Participation in this offer constitutes acceptance of these terms and conditions. CashKaro’s decision regarding all aspects of the offer will be final and binding.</li>
  </ul>`},
];


export default function MysteryBoxCongratsNov() {

  const [alertOpen, setAlertOpen] = useState(true);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(1);
  const [Reveal, setReveal] = useState(false);
  const [bonus,setBonus] = useState(localStorage.getItem('mb_bonus_feb') || 0)
  const [isPastCta1,setIsPastCta1] = useState(false)
  const cta1Ref = useRef(null)
  const handleImageClick = () => {
    setReveal(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

      useEffect(() => {
      console.log(isPastCta1)
    
        const observer = new IntersectionObserver(
          ([entry]) => {
            setIsPastCta1(!entry.isIntersecting);
          },
          { threshold: 0.1 }
        );
    
        if (cta1Ref.current) {
          observer.observe(cta1Ref.current);
        }
    
        return () => {
          if (cta1Ref.current) {
            observer.unobserve(cta1Ref.current);
          }
        };
      }, []);

  const showAlert = () => {
    setAlertOpen(true);
  };

  const closeAlert = () => {
    setAlertOpen(false);
  };
  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}
        sx={{
          backgroundImage: `url(${Bg})`,
          minHeight:'100vh'
        }}>
        <Box sx={{
          position: 'relative', width: '100%', height: '100vh', overflow: 'hidden',
        }}>
          {/* Video Background */}
          {/* <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          >
            <source src="https://d2sriifpjiqv0p.cloudfront.net/Open.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}

<img src={OpenBox}  style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }} />
          <Box
            sx={{
              backgroundImage: `url(${ctaImage})`,
              width: '100%',
              height: '100%',
              position: 'absolute',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              top: 0,
              left: 0,
              right: 0
            }}
          >
            <div
              className="slide-up"
              style={{
                display: 'flex',
                flexDirection: 'column', // Stacks children vertically
                alignItems: 'center',    // Centers items horizontally
                paddingTop: '28px',

              }}
            >
              <Typography
                sx={{
                  fontFamily: 'DM Sans',
                  fontWeight: '800',
                  fontSize: '22px',
                  lineHeight: '22px',
                  color: '#fff'
                }}
              >
                CONGRATULATIONS
              </Typography>
              {/* <img src={Heading} alt="heading" style={{ width: '100%' }} /> */}
              <Typography py={1.6} mt={1.5} sx={{backgroundImage: `url(${Gradiant})`,width:'301px',borderRadius:'68px', textAlign:'center',fontFamily:'DM Sans', fontWeight:'900',fontSize:'24px',lineHeight:'28.8px',color:'#fff'}}>You got ₹{bonus}</Typography>

            </div>

            <div style={{
              paddingLeft:'1rem',
              paddingRight:'1rem',
              display: 'flex',
              justifyContent: 'center',
              bottom:'15%',
              position:'absolute',
              width: '100%',
              // alignItems: 'center', // Ensures vertical alignment if needed
            }}>
             
  <Typography sx={{fontFamily:'DM Sans',textAlign:'center',fontWeight:'600', fontSize:'14px', lineHeight:'18.2px',color:'#fff'}}>
  It may take up to 72 hours for your bonus to reflect in your "My Order Details" section.
  </Typography>
                </div>
            <div ref={cta1Ref} style={{
              display: 'flex',
              justifyContent: 'center',
              bottom:'0',
              background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
              width: '100%',
              position: 'fixed',
              zIndex: '9999999',
              // alignItems: 'center', // Ensures vertical alignment if needed
            }}>
             <a href='cashkaro://my-earnings'>
                <img
                  src={Bonus}
                  alt="Bonus"
                  style={{ width: '100%' }}
                />
                </a>
                </div>
          </Box>

          {/* Overlay Content */}
        </Box>

        <Box sx={{ background: '#1c4563', paddingX: '18px' }}>
          <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '5px' }}>FAQs</Typography>
          {faqs.map((faq, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                background:
                  "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                borderRadius: "14px",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  background: "#355974",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  fontFamily: 'DM Sans'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#FFEEC3', }}>
                  {faq?.question}
                </AccordionSummary>
                <AccordionDetails>{faq?.answer}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
        <Box sx={{ background: '#1c4563', paddingX: '18px' }} pb={16}>
          <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
          {Terms.map((Terms, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                background:
                  "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                borderRadius: "14px",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  background: "#355974",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  fontFamily: 'DM Sans'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#FFEEC3', }}>
                  {Terms?.question}
                </AccordionSummary>
                <AccordionDetails>{ReactHtmlParser(Terms?.answer)}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
        {/* <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} /> */}
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
